// Zentrale SEO-Daten (Single Source of Truth).
// Wird verwendet von: App.js (Seo-Komponente, Laufzeit), Schema.jsx (JSON-LD, Laufzeit)
// und indirekt vom Prerendering (scripts/capture-prerender.py liest die gerenderten Werte).
// Bei Textaenderungen an Titles/Descriptions HIER pflegen und danach
// das Prerendering neu erfassen: yarn build && python3 scripts/capture-prerender.py

export const SITE_URL = "https://davidfrank.at";
export const SITE_NAME = "David Frank — Leadership Psychologie";

// Urspruengliche globale Description (Impressum/Datenschutz behalten sie unveraendert)
export const DEFAULT_DESCRIPTION =
  "David Frank verbindet Leadership-, Team- und Organisationsentwicklung mit psychologischer Tiefe. Coaching, Training und Organisationsentwicklung für wirksame Führung und Zusammenarbeit.";

export const PAGES = {
  "/": {
    title: "Leadership Training & Team Performance mit psychologischer Tiefe – David Frank",
    description:
      "Psychologische Tiefe trifft Business Performance. David Frank verbindet Leadership, Team- und Organisationsentwicklung mit psychologischem Know-how.",
  },
  "/leadership": {
    title: "Führungskräfteentwicklung | Menschliche Dynamiken verstehen lernen – David Frank",
    description:
      "Gute Führung beginnt nicht mit Methoden. Sie beginnt mit dem Verständnis für Menschen. David Frank verbindet Leadership, Psychologie und Organisationsentwicklung und entwickelt Kompetenz fürs Menschliche und Zwischenmenschliche.",
  },
  "/team": {
    title: "Teamentwicklung | Zwischen Kuschelgruppe und High Performance – David Frank",
    description:
      "Was macht ein Team wirklich leistungsfähig? Teamentwicklung mit psychologischer Sicherheit, Klarheit und dem Mut, anzusprechen, was wirklich los ist.",
  },
  "/organisation": {
    title: "Organisationsentwicklung | Menschen bei Veränderungen mitnehmen – David Frank",
    description:
      "Veränderung ist nicht nur ein strukturelles Thema. Change Management, das Menschen auf der Reise in die neue Welt mitnimmt – und Organisationen nachhaltig verändert.",
  },
  "/strategie": {
    title: "Strategieentwicklung | Auf instabilen Zeiten surfen lernen – David Frank",
    description:
      "Die Zukunft lässt sich nicht vorhersagen. Dynamische Strategieentwicklung hilft Organisationen, Unsicherheit zu nutzen, Entscheidungen zu treffen und handlungsfähig zu bleiben.",
  },
  "/ueber-mich": {
    title: "David Frank | Leadership Training & Teamentwicklung mit psychologischer Tiefe",
    description:
      "Vom Ingenieur zur Psychologie der Zusammenarbeit: David Frank verbindet Leadership, Psychologie und Organisationsentwicklung mit Erfahrung aus der Unternehmenspraxis.",
  },
  "/impressum": {
    title: "Impressum — David Frank",
    description: DEFAULT_DESCRIPTION,
  },
  "/datenschutz": {
    title: "Datenschutzerklärung — David Frank",
    description: DEFAULT_DESCRIPTION,
  },
};

export const canonicalFor = (pathname) =>
  pathname === "/" ? `${SITE_URL}/` : `${SITE_URL}${pathname}`;
